module.exports = __webpack_public_path__ + "static/footer-bg-6a4c4eef1c9ed373b0afdabf7addc15b.jpg";